import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: inline-grid;
  grid-template-columns: 72px auto;
  align-items: center;
  gap: 14px;

  svg {
    width: 72px;
    height: 72px;
    transform: rotate(-90deg);
    grid-row: 1;
    grid-column: 1;
  }

  circle {
    fill: none;
    stroke-width: 5;
  }

  .track {
    stroke: rgba(246, 241, 232, 0.14);
  }

  .value {
    stroke-linecap: round;
    transition: stroke-dashoffset 1.2s var(--ease);
    animation: ring 1.2s var(--ease);
  }

  @keyframes ring {
    from {
      stroke-dashoffset: 163;
    }
  }

  .score {
    grid-row: 1;
    grid-column: 1;
    display: grid;
    place-items: center;
    font-family: var(--font-display);
    font-size: 22px;
    font-weight: 800;
  }

  .label {
    display: flex;
    flex-direction: column;
    font-family: var(--font-mono);
    font-size: 11px;
    letter-spacing: 0.12em;
    text-transform: uppercase;

    small {
      font-size: 11px;
      letter-spacing: 0.04em;
      text-transform: none;
      opacity: 0.6;
    }
  }
`;
